import { DbFinishTransfer } from "../../../data/usecases/finish-transfer";
import { FinishTransfer } from "../../../domain/usecases/finish-transfer";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeFinishTransfer = (): FinishTransfer =>
  new DbFinishTransfer(
    makeApiUrl("/transfer/"),
    makeAuthorizeHttpClientDecorator()
  );
